module.exports = __webpack_public_path__ + "static/media/AngelsOfAether_Race_01.19119d32.jpg";